export default "__VITE_ASSET__BmJIKVHB__"